export const BATAS_PERANGKAT_PUSH = 10
export const PANJANG_TOKEN_MIN = 20
export const PANJANG_TOKEN_MAKS = 4096
export const KUNCI_SIMPANAN_PUSH = "pdk-push"
export const VERSI_SDK_WEB = "10.12.0"

export interface KonfigWebPush {
  apiKey: string
  authDomain: string
  projectId: string
  messagingSenderId: string
  appId: string
  vapidKey: string
}

export interface PerangkatPush {
  id: string
  nama: string
  dibuatPada: string
  terakhirAktif: string
}

export interface IsiPush {
  judul: string
  isi: string
  tautan: string | null
}

export function konfigWebLengkap(masukan: Partial<KonfigWebPush>): masukan is KonfigWebPush {
  return Boolean(masukan.apiKey && masukan.projectId && masukan.messagingSenderId && masukan.appId && masukan.vapidKey)
}

export function tokenPushSah(token: unknown): token is string {
  return typeof token === "string" && token.length >= PANJANG_TOKEN_MIN && token.length <= PANJANG_TOKEN_MAKS && /^[A-Za-z0-9_:\-.]+$/.test(token)
}

export function rapikanNamaPerangkat(mentah: unknown): string {
  const nama = typeof mentah === "string" ? mentah.trim().replace(/\s+/g, " ").slice(0, 60) : ""
  return nama || "Perangkat tanpa nama"
}

export function potong(teks: string, maks: number): string {
  const huruf = Array.from(teks.trim())
  return huruf.length <= maks ? huruf.join("") : `${huruf.slice(0, maks - 1).join("")}…`
}

export function susunPesanFcm(token: string, isi: IsiPush, urlDasar: string): Record<string, unknown> {
  const tautan = isi.tautan && isi.tautan.startsWith("/") && !isi.tautan.startsWith("//") ? `${urlDasar}${isi.tautan}` : null
  return {
    message: {
      token,
      notification: { title: potong(isi.judul, 80), body: potong(isi.isi, 180) },
      data: { tautan: tautan ?? "" },
      webpush: { ...(tautan && tautan.startsWith("https://") ? { fcm_options: { link: tautan } } : {}), headers: { TTL: "86400" } },
    },
  }
}

export function tokenTidakBerlaku(status: number, badan: unknown): boolean {
  if (status === 404) return true
  const rincian = (badan as { error?: { details?: Array<{ errorCode?: string }>; status?: string } } | null)?.error
  if (rincian?.details?.some((item) => item.errorCode === "UNREGISTERED")) return true
  return status === 400 && rincian?.status === "INVALID_ARGUMENT"
}

export function buatSkripPekerja(konfig: Omit<KonfigWebPush, "vapidKey">): string {
  const aman = JSON.stringify({ apiKey: konfig.apiKey, authDomain: konfig.authDomain, projectId: konfig.projectId, messagingSenderId: konfig.messagingSenderId, appId: konfig.appId }).replace(/</g, "\\u003c")
  return `importScripts("https://www.gstatic.com/firebasejs/${VERSI_SDK_WEB}/firebase-app-compat.js", "https://www.gstatic.com/firebasejs/${VERSI_SDK_WEB}/firebase-messaging-compat.js");
firebase.initializeApp(${aman});
firebase.messaging();
`
}

export function namaDariUserAgent(ua: string): string {
  const browser = /Edg\//.test(ua) ? "Edge" : /OPR\/|Opera/.test(ua) ? "Opera" : /Firefox\//.test(ua) ? "Firefox" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : "Browser"
  const os = /Android/.test(ua) ? "Android" : /iPhone|iPad|iPod/.test(ua) ? "iOS" : /Windows/.test(ua) ? "Windows" : /Mac OS X/.test(ua) ? "macOS" : /Linux/.test(ua) ? "Linux" : "perangkat ini"
  return `${browser} di ${os}`
}
